import React, { useState } from 'react'

import { subscriptionAPI } from '../../../api/services/subscription'
import { SubscriptionPricing } from '../../../api/services/subscription/types.ts'
import Button from '../../common/Button/Button.tsx'
import SubscriptionRadioButtons from '../radioButtons/SubscriptionRadioButtons.tsx'

const SubscriptionsList = ({ prices }: { prices: SubscriptionPricing[] }) => {
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [selectedPlan, setSelectedPlan] = useState<string>('')

  const handleSubmit = async () => {
    setLoading(true)
    const tpayWindow = window.open('', '_blank')
    try {
      const response = await subscriptionAPI.subscriptionCreateSessions({
        price_id: selectedPlan
      })
      if (response.error) {
        setMessage(response.error)
        setLoading(false)
        return
      }
      if (response.checkout_session) {
        const url = response.checkout_session
        if (tpayWindow)
          tpayWindow.location.href = url
      }
    } catch {
      setMessage(
        'Wystąpił błąd. Wróć za chwilę'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex flex-col max-w-2xl mx-auto bg-white dark:bg-gray-700 rounded-xl shadow-md mt-8 p-8 space-y-6">
      <SubscriptionRadioButtons
        label={''}
        handleRadioChange={setSelectedPlan}
        selectedValue={selectedPlan}
        prices={prices}
      />

      <Button
        onClick={handleSubmit}
        variant="filled"
        size="large"
        color="primary"
        type="submit"
        className="my-8 text-[20px]"
        disabled={loading || selectedPlan === ''}
      >
        {loading ? 'Proszę czekać...' : 'Przejdź do płatności'}
      </Button>

      {message && (
        <div
          className={`text-center text-sm rounded-md p-2 ${
            message.toLowerCase().includes('błąd') ||
            message.toLowerCase().includes('error')
              ? 'bg-red-100 text-red-700'
              : 'bg-green-100 text-green-700'
          }`}
        >
          {message}
        </div>
      )}
    </div>
  )
}

export default SubscriptionsList
